
export class NpsPagination<T> {
  data: T[];
  meta: INpsPaginationMeta;
}

export interface INpsPaginationMeta {
  total: number;
  lastPage: number;
  currentPage: number;
  perPage: number;
  prev: number;
  next: number;
}
